module.exports = __webpack_public_path__ + "static/media/sneak-peek-onboarding.a8369bb2.png";